// extracted by mini-css-extract-plugin
module.exports = {"mentions":"mention_mentions___pM3D"};